export enum Module {
  Absence = "absence",
  Appointment = "appointment",
  CalendarItem = "calendarItem",
  CompanyDetails = "companyDetails",
  Customer = "customer",
  Onboarding = "onboarding",
  OpeningHour = "openingHour",
  Setting = "setting",
  Treatment = "treatment",
  Permission = "permission",
  User = "user",
  WorkingHour = "workingHour",
  Payment = "payment",
}
